import React from 'react';
import { ajaxPost, AjaxResponseType } from '../../common/form/FrekulForm';

export const defaultNextoneOrderClient = {
  // 追加したメタ情報の更新
  updateArtistWork(formHash: string, form: {
    lyric_writer_name_kana: string,
    composer_name_kana: string,
  }): Promise<AjaxResponseType> {
    return ajaxPost(`/nextone_orders/ajax_update_artist_work/${formHash}`, form, {}, true);
  },
  // 他の著作者から著作権を受け取る
  validateCopyrightCollectStep1(formHash: string, form: {
    copyright_transfer_type: string,
    karaoke_authors: {
      email: string,
      pseudonym: string,
    }[],
  }): Promise<AjaxResponseType> {
    const postData = {
      copyright_transfer_type: form.copyright_transfer_type,
    } as { [key: string]: string };
    form.karaoke_authors.forEach((karaokeAuthor, index) => {
      postData[`karaoke_authors[${index}][email]`] = karaokeAuthor.email;
      postData[`karaoke_authors[${index}][pseudonym]`] = karaokeAuthor.pseudonym;
    });
    return ajaxPost(`/nextone_orders/ajax_validate_copyright_collect_step1/${formHash}`, postData, {}, true);
  },
  validateCopyrightCollectStep2(formHash: string, form: {
    copyright_transfer_type: string,
    applicant_address: string,
    karaoke_authors: {
      email: string,
      pseudonym: string,
    }[],
  }): Promise<AjaxResponseType & {
    document: string,
    emailSubject: string,
    emailBody: string,
  }> {
    const postData = {
      copyright_transfer_type: form.copyright_transfer_type,
      applicant_address: form.applicant_address,
    } as { [key: string]: string };
    form.karaoke_authors.forEach((karaokeAuthor, index) => {
      postData[`karaoke_authors[${index}][email]`] = karaokeAuthor.email;
      postData[`karaoke_authors[${index}][pseudonym]`] = karaokeAuthor.pseudonym;
    });
    return ajaxPost(`/nextone_orders/ajax_validate_copyright_collect_step2/${formHash}`, postData, {}, true);
  },
  executeCopyrightCollect(formHash: string, form: {
    copyright_transfer_type: string,
    applicant_address: string,
    karaoke_authors: {
      email: string,
      pseudonym: string,
    }[],
  }): Promise<AjaxResponseType> {
    const postData = {
      copyright_transfer_type: form.copyright_transfer_type,
      applicant_address: form.applicant_address,
    } as { [key: string]: string };
    form.karaoke_authors.forEach((karaokeAuthor, index) => {
      postData[`karaoke_authors[${index}][email]`] = karaokeAuthor.email;
      postData[`karaoke_authors[${index}][pseudonym]`] = karaokeAuthor.pseudonym;
    });
    return ajaxPost(`/nextone_orders/ajax_execute_copyright_collect/${formHash}`, postData, {}, true);
  },
  // 申込者からWSに著作権を譲渡（他に著作者がいない場合）
  validateIndependentCopyrightTransfer(formHash: string, form: {
    copyright_transfer_type: string,
    applicant_address: string,
  }): Promise<AjaxResponseType & {
    document: string,
  }> {
    const postData = {
      copyright_transfer_type: form.copyright_transfer_type,
      applicant_address: form.applicant_address,
    };
    return ajaxPost(`/nextone_orders/ajax_validate_independent_copyright_transfer/${formHash}`, postData, {}, true);
  },
  executeIndependentCopyrightTransfer(formHash: string, form: {
    copyright_transfer_type: string,
    applicant_address: string,
  }): Promise<AjaxResponseType> {
    const postData = {
      copyright_transfer_type: form.copyright_transfer_type,
      applicant_address: form.applicant_address,
    };
    return ajaxPost(`/nextone_orders/ajax_execute_independent_copyright_transfer/${formHash}`, postData, {}, true);
  },
  // 著作者から申込者に著作権を譲渡
  validateAuthorCopyrightTransfer(formHash: string, form: { [key: string]: string }): Promise<AjaxResponseType & {
    document: string,
  }> {
    return ajaxPost(`/nextone_orders/ajax_validate_author_copyright_transfer/${formHash}`, form, {}, true);
  },
  executeAuthorCopyrightTransfer(formHash: string, form: { [key: string]: string }): Promise<AjaxResponseType> {
    return ajaxPost(`/nextone_orders/ajax_execute_author_copyright_transfer/${formHash}`, form, {}, true);
  },
  // 申込者からWSに著作権を譲渡（他の著作者から著作権を受け取った後）
  validateRecipientCopyrightTransfer(formHash: string): Promise<AjaxResponseType & {
    document: string,
  }> {
    return ajaxPost(`/nextone_orders/ajax_validate_recipient_copyright_transfer/${formHash}`, {}, {}, true);
  },
  executeRecipientCopyrightTransfer(formHash: string): Promise<AjaxResponseType> {
    return ajaxPost(`/nextone_orders/ajax_execute_recipient_copyright_transfer/${formHash}`, {}, {}, true);
  },
  validateRecipientCopyrightTransferAmendment(formHash: string, address: string): Promise<AjaxResponseType & {
    document: string,
  }> {
    const postData = {
      applicant_address: address,
    };
    return ajaxPost(`/nextone_orders/ajax_validate_recipient_copyright_transfer_agreement_amendment/${formHash}`, postData, {}, true);
  },
  executeRecipientCopyrightTransferAmendment(formHash: string, address: string): Promise<AjaxResponseType> {
    const postData = {
      applicant_address: address,
    };
    return ajaxPost(`/nextone_orders/ajax_execute_recipient_copyright_transfer_agreement_amendment/${formHash}`, postData, {}, true);
  },
};

export const NextoneOrderClientContext = React.createContext(defaultNextoneOrderClient);

